export const SET_USER = 'BASIC_INFO/SET_USER';
export const SET_USER_ID = 'BASIC_INFO/SET_USER_ID';
export const SET_IS_ADMIN_USER = 'BASIC_INFO/SET_IS_ADMIN_USER';
export const SET_USER_MFA = 'BASIC_INFO/SET_USER_MFA';
export const SET_USER_RESALE_ID = 'BASIC_INFO/SET_USER_RESALE_ID';
export const CLEAR_PASSWORD = 'BASIC_INFO/CLEAR_PASSWORD';
export const CLEAR_BASIC_INFORMATION = 'BASIC_INFO/CLEAR_BASIC_INFORMATION';
export const HANDLE_LOADING = 'BASIC_INFO/HANDLE_LOADING';
export const SET_USER_RESTRICTIONS = 'BASIC_INFO/SET_USER_RESTRICTIONS';
export const SET_IS_CONSULT_NEW_PASSWORD_TERMS_REQUEST_DONE = 'BASIC_INFO/SET_IS_CONSULT_NEW_PASSWORD_TERMS_REQUEST_DONE';
export const SET_IS_CONSULT_USER_NEW_PASSWORD_TERMS_REQUEST_DONE = 'BASIC_INFO/SET_IS_CONSULT_USER_NEW_PASSWORD_TERMS_REQUEST_DONE';
export const SET_USER_OWN_TERMS = 'BASIC_INFO/SET_USER_OWN_TERMS';
export const SET_IS_USER_TERMS_NOT_ACCEPTED = 'BASIC_INFO/SET_IS_USER_TERMS_NOT_ACCEPTED';